import { 
	GetClassesActionsTypes,
	CreateClassActionsTypes, CreateClassModel,
	UpdateClassActionsTypes,
	DeleteClassActionsTypes
} from './types';

export const getClassesRequest  = () => (
	{
		type: GetClassesActionsTypes.GET_CLASSES,		
	}
);

export const createClassRequest  = (model: CreateClassModel) => (
	{
		type: CreateClassActionsTypes.POST_CREATE_CLASS,
		model		
	}
);

export const updateClassRequest  = (id: number, model: any) => (
	{
		type: UpdateClassActionsTypes.PUT_UPDATE_CLASS,
		id,
		model		
	}
);

export const deleteClassRequest  = (id: number) => (
	{
		type: DeleteClassActionsTypes.DELETE_CLASS,
		id		
	}
);
